import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-29652af9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filter-panel" }
const _hoisted_2 = { class: "filter-panel__toolbar" }
const _hoisted_3 = { class: "filter-panel__left" }
const _hoisted_4 = { class: "filter-panel__primary" }
const _hoisted_5 = {
  key: 0,
  class: "filter-panel__actions"
}
const _hoisted_6 = {
  key: 0,
  class: "filter-panel__advanced"
}
const _hoisted_7 = { class: "filter-panel__advanced-fields" }
const _hoisted_8 = { class: "filter-panel__drawer-fields" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_el_collapse_transition = _resolveComponent("el-collapse-transition")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.$slots.advanced)
          ? (_openBlock(), _createBlock(_component_el_badge, {
              key: 0,
              hidden: _ctx.activeCount === 0,
              value: _ctx.activeCount
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_tooltip, {
                  content: _ctx.filtersExpanded ? 'Hide filters' : 'More filters',
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      "aria-expanded": _ctx.filtersExpanded,
                      circle: "",
                      class: "filter-panel__toggle",
                      icon: _ctx.filtersExpanded ? 'ArrowUp' : 'ArrowDown',
                      plain: "",
                      size: "small",
                      type: "primary",
                      onClick: _ctx.toggleFilters
                    }, null, 8, ["aria-expanded", "icon", "onClick"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }, 8, ["hidden", "value"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "primary", {}, undefined, true)
        ])
      ]),
      (_ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_collapse_transition, null, {
      default: _withCtx(() => [
        (!_ctx.isMobile && _ctx.filtersExpanded)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _renderSlot(_ctx.$slots, "advanced", {}, undefined, true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }),
    (_ctx.isMobile)
      ? (_openBlock(), _createBlock(_component_el_drawer, {
          key: 0,
          "model-value": _ctx.filtersExpanded,
          direction: "rtl",
          size: "min(360px, 92vw)",
          title: "Additional filters",
          "onUpdate:modelValue": _ctx.setFiltersExpanded
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _renderSlot(_ctx.$slots, "advanced", {}, undefined, true)
            ])
          ]),
          _: 3
        }, 8, ["model-value", "onUpdate:modelValue"]))
      : _createCommentVNode("", true)
  ]))
}